$(function() {
  autoTargetLinks();
});
